import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Box, Chip, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import ViewListOutlinedIcon from '@mui/icons-material/ViewListOutlined';
import moment from 'moment';
import InvoiceThumbView from '../contentView/invoiceThumbView';
import InvoiceTableView from '../contentView/invoiceTableView';
import { utilMethods } from '../../util/util';
import { changeInvoiceView, clearSearchInvoice } from '../../actions/invoiceDateActions';

class InvoiceContent extends Component {
    getEndDate = (endDate) => {
        const now = moment();
        if (endDate <= now) {
            return endDate.year() === now.year() && endDate.month() === now.month() ? now : endDate;
        }
        return now;
    };

    bindInvoicesByDate = () => {
        if (this.props.invSearchRes.isSearch) return this.props.invSearchRes.data;
        const { selectedYear, selectedMonth } = this.props.invoiceSelectedDate;
        const startDate = moment(`${selectedYear}/${selectedMonth}/01`).startOf('month');
        const endDate = this.getEndDate(moment(`${selectedYear}/${selectedMonth}/01`).endOf('month'));
        const monthDates = utilMethods.enumerateDaysBetweenDates(startDate, endDate);
        const listData = [];
        monthDates.forEach((cDate) => {
            (this.props.invoiceList || []).forEach((item) => {
                if (moment(item.createdDate).format('YYYY/MM/DD') === moment(cDate).format('YYYY/MM/DD')) {
                    listData.push(item);
                }
            });
        });
        return listData;
    };

    render() {
        const { invoiceSelectedDate, invoiceView, invSearchRes, dispatch } = this.props;
        const isTableView = invoiceView && invoiceView.isTableView;
        const invoices = this.bindInvoicesByDate();
        const monthLabel = moment()
            .month(invoiceSelectedDate.selectedMonth - 1)
            .year(invoiceSelectedDate.selectedYear)
            .format('MMMM YYYY');

        return (
            <>
                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1.5, mb: 2 }}>
                    <Typography variant="h6" component="h2" sx={{ flex: 1 }}>
                        {invSearchRes.isSearch ? 'Search results' : monthLabel}
                    </Typography>
                    {invSearchRes.isSearch && (
                        <Chip label="Clear search" onDelete={() => dispatch(clearSearchInvoice())} onClick={() => dispatch(clearSearchInvoice())} />
                    )}
                    <ToggleButtonGroup
                        size="small"
                        exclusive
                        value={isTableView ? 'list' : 'cards'}
                        onChange={(e, value) => value && dispatch(changeInvoiceView(value === 'list'))}
                        aria-label="Tow sheet layout"
                    >
                        <ToggleButton value="cards" aria-label="Cards">
                            <GridViewOutlinedIcon fontSize="small" />
                        </ToggleButton>
                        <ToggleButton value="list" aria-label="List">
                            <ViewListOutlinedIcon fontSize="small" />
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Box>
                {isTableView ? (
                    <InvoiceTableView invoiceList={invoices} invoiceSelectedDate={invoiceSelectedDate} />
                ) : (
                    <InvoiceThumbView invoiceList={invoices} invoiceSelectedDate={invoiceSelectedDate} />
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    invoiceSelectedDate: state.invoiceSelectedDate,
    invoiceView: state.invoiceView,
    invoiceList: state.invoiceList.formattedList,
    invSearchRes: state.invSearchRes,
});

export default connect(mapStateToProps)(InvoiceContent);
